/**
 * PH theme additions (Warehouse loads this asset — keep vendor code out of theme.js).
 * Read More: `sections/ph-seo-intro.liquid` when “Collapse long body with Read more” is enabled.
 * Global Elfsight Heritage ratings sticker: see second IIFE at file bottom.
 */
(function () {
  function setReadMoreExpanded(root, expanded) {
    var btn = root.querySelector("[data-ph-seo-readmore-btn]");
    var fade = root.querySelector("[data-ph-seo-fade]");
    var label = btn && btn.querySelector(".ph-seo-readmore__label");
    if (!btn) {
      return;
    }
    var moreL = btn.getAttribute("data-label-more") || "Read more";
    var lessL = btn.getAttribute("data-label-less") || "Read less";
    root.classList.toggle("ph-seo-readmore--expanded", expanded);
    btn.setAttribute("aria-expanded", expanded ? "true" : "false");
    if (label) {
      label.textContent = expanded ? lessL : moreL;
    }
    if (fade) {
      if (root.getAttribute("data-show-fade") === "false") {
        fade.hidden = true;
      } else {
        fade.hidden = expanded;
      }
    }
  }

  function initSeoReadMore(root) {
    if (root.getAttribute("data-ph-readmore-done") === "true") {
      return;
    }
    var clip = root.querySelector(".ph-seo-readmore__clip");
    var btn = root.querySelector("[data-ph-seo-readmore-btn]");
    if (!clip || !btn) {
      return;
    }
    var maxD = parseInt(root.getAttribute("data-max-px"), 10);
    var maxM = parseInt(root.getAttribute("data-max-px-mobile"), 10);
    if (isNaN(maxD) || maxD < 1) {
      maxD = 360;
    }
    if (isNaN(maxM) || maxM < 1) {
      maxM = 220;
    }
    var useWide = window.matchMedia("(min-width: 750px)").matches;
    var maxPx = useWide ? maxD : maxM;
    var fullH = clip.scrollHeight;
    root.setAttribute("data-ph-readmore-done", "true");
    if (fullH <= maxPx) {
      return;
    }
    root.classList.add("ph-seo-readmore--initialized");
    root.classList.remove("ph-seo-readmore--expanded");
    root.style.setProperty("--ph-readmore-max", maxPx + "px");
    btn.hidden = false;
    setReadMoreExpanded(root, false);
    btn.addEventListener("click", function () {
      var isExp = root.classList.contains("ph-seo-readmore--expanded");
      setReadMoreExpanded(root, !isExp);
    });
  }

  function initAllReadMoreIn(scope) {
    var el = scope && scope.querySelectorAll ? scope : document;
    el.querySelectorAll("[data-ph-seo-readmore]").forEach(function (r) {
      initSeoReadMore(r);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAllReadMoreIn(document);
    });
  } else {
    initAllReadMoreIn(document);
  }

  document.addEventListener("shopify:section:load", function (e) {
    if (e && e.target && e.target.querySelectorAll) {
      initAllReadMoreIn(e.target);
    }
  });
})();

/**
 * Elfsight Heritage “ratings sticker” on every storefront page (Warehouse `theme.liquid`
 * and `gift-card` load this file; no vendor layout edits). Matches
 * `sections/ph-elfsight-google-reviews.liquid` preset `heritage_ratings_sticker`.
 * Skips if the placeholder already exists (e.g. merchant added the section in Theme Editor).
 */
(function () {
  var STICKER_CLASS = "elfsight-app-edd8b611-565e-4e39-a417-bcb966ead3e5";
  var PLATFORM_SUB = "elfsightcdn.com/platform.js";

  function platformScriptPresent() {
    return !!document.querySelector('script[src*="' + PLATFORM_SUB + '"]');
  }

  function stickerPresent() {
    return !!document.body && !!document.body.querySelector("." + STICKER_CLASS);
  }

  function ensurePlatformScript() {
    if (platformScriptPresent()) {
      return;
    }
    var s = document.createElement("script");
    s.src = "https://elfsightcdn.com/platform.js";
    s.async = true;
    document.head.appendChild(s);
  }

  function mountSticker() {
    if (!document.body || stickerPresent()) {
      return;
    }
    var wrap = document.createElement("div");
    wrap.id = "ph-global-elfsight-sticker";
    wrap.className = "ph-elfsight-google-reviews ph-elfsight-google-reviews--floating";
    wrap.setAttribute("aria-label", "Perfect Home Furniture on Google Reviews");

    var inner = document.createElement("div");
    inner.className = STICKER_CLASS;
    inner.setAttribute("data-elfsight-app-lazy", "");
    wrap.appendChild(inner);

    document.body.appendChild(wrap);
  }

  function initGlobalElfsightSticker() {
    if (stickerPresent()) {
      return;
    }
    mountSticker();
    ensurePlatformScript();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initGlobalElfsightSticker);
  } else {
    initGlobalElfsightSticker();
  }
})();

/**
 * Article image lightbox: tap/click to open, pinch/wheel to zoom, swipe to
 * browse. Zoom lives on a transform inside the overlay so the page behind
 * it never zooms or scrolls. Article pages only (`body.template-article`).
 */
(function () {
  var MIN_SCALE = 1;
  var MAX_SCALE = 4;
  var DOUBLE_TAP_SCALE = 2.5;
  var DOUBLE_TAP_MS = 300;
  var DOUBLE_TAP_PX = 40;
  var SWIPE_X = 60;
  var SWIPE_Y = 80;
  var MOVE_PX = 8;
  var SELECTOR = ".article__image-wrapper img, .article__content img";

  var images = [];
  var index = 0;
  var root = null;
  var stage = null;
  var imgEl = null;
  var captionEl = null;
  var counterEl = null;
  var prevBtn = null;
  var nextBtn = null;
  var closeBtn = null;
  var lastFocus = null;
  var scrollY = 0;
  var open = false;
  var scale = 1;
  var tx = 0;
  var ty = 0;
  var pointers = {};
  var pointerCount = 0;
  var pinchStartDist = 0;
  var pinchStartScale = 1;
  var pinchStartTx = 0;
  var pinchStartTy = 0;
  var pinchOriginX = 0;
  var pinchOriginY = 0;
  var panLastX = 0;
  var panLastY = 0;
  var gestureStartX = 0;
  var gestureStartY = 0;
  var didPinch = false;
  var didMove = false;
  var lastTapAt = 0;
  var lastTapX = 0;
  var lastTapY = 0;
  var currentSource = null;
  var hiResToken = 0;

  function isArticlePage() {
    return !!(document.body && document.body.classList.contains("template-article"));
  }

  function clamp(n, min, max) {
    return Math.min(max, Math.max(min, n));
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function pickSource(img) {
    var src = img.currentSrc || img.getAttribute("src") || "";
    var srcset = img.getAttribute("srcset");
    if (!srcset) {
      return src;
    }
    var parts = srcset.split(",");
    var best = 0;
    var bestUrl = "";
    var i;
    for (i = 0; i < parts.length; i++) {
      var bits = parts[i].trim().split(/\s+/);
      var url = bits[0];
      var desc = bits[1] || "";
      var w = desc.charAt(desc.length - 1) === "w" ? parseInt(desc, 10) : 0;
      if (url && w >= best) {
        best = w;
        bestUrl = url;
      }
    }
    return bestUrl || src;
  }

  function toHiRes(img) {
    var src = pickSource(img);
    if (!src) {
      return src;
    }
    try {
      var url = new URL(src, window.location.href);
      url.pathname = url.pathname.replace(
        /_(\d+x\d+|\d+x|x\d+|pico|icon|thumb|small|compact|medium|large|grande|original|master)(\.(?:jpe?g|png|gif|webp|avif))$/i,
        "$2"
      );
      url.searchParams.set("width", "2400");
      url.searchParams.delete("height");
      url.searchParams.delete("h");
      return url.toString();
    } catch (err) {
      return src;
    }
  }

  function skipImage(img) {
    if (!img || img.getAttribute("data-no-zoom") != null) {
      return true;
    }
    return !!img.closest("a");
  }

  function collectImages(scope) {
    var list = [];
    var nodes = (scope || document).querySelectorAll(SELECTOR);
    var i;
    for (i = 0; i < nodes.length; i++) {
      if (!skipImage(nodes[i])) {
        list.push(nodes[i]);
      }
    }
    return list;
  }

  function refreshImageList() {
    images = collectImages(document);
  }

  function stageCenter() {
    var rect = stage.getBoundingClientRect();
    return { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 };
  }

  function pointFromClient(clientX, clientY) {
    var c = stageCenter();
    return { x: clientX - c.x, y: clientY - c.y };
  }

  function applyTransform(animate) {
    if (!imgEl) {
      return;
    }
    var useAnim = !!animate && !prefersReducedMotion();
    imgEl.style.transition = useAnim ? "transform 200ms ease" : "none";
    imgEl.style.transform = "translate(" + tx + "px, " + ty + "px) scale(" + scale + ")";
    if (root) {
      root.classList.toggle("is-zoomed", scale > 1.01);
    }
  }

  function clampPan() {
    if (!imgEl || !stage || scale <= 1) {
      tx = 0;
      ty = 0;
      return;
    }
    var sw = stage.clientWidth;
    var sh = stage.clientHeight;
    var iw = imgEl.offsetWidth * scale;
    var ih = imgEl.offsetHeight * scale;
    var maxX = Math.max(0, (iw - sw) / 2 + 24);
    var maxY = Math.max(0, (ih - sh) / 2 + 24);
    tx = clamp(tx, -maxX, maxX);
    ty = clamp(ty, -maxY, maxY);
  }

  function zoomToward(nextScale, originX, originY) {
    nextScale = clamp(nextScale, MIN_SCALE, MAX_SCALE);
    if (nextScale === scale) {
      return;
    }
    var factor = nextScale / scale;
    tx = originX - (originX - tx) * factor;
    ty = originY - (originY - ty) * factor;
    scale = nextScale;
    if (scale <= MIN_SCALE) {
      scale = MIN_SCALE;
      tx = 0;
      ty = 0;
    } else {
      clampPan();
    }
  }

  function resetZoom() {
    scale = MIN_SCALE;
    tx = 0;
    ty = 0;
    applyTransform(false);
  }

  function lockScroll() {
    scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = "fixed";
    document.body.style.top = "-" + scrollY + "px";
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.overflow = "hidden";
    document.body.style.width = "100%";
    document.documentElement.style.overflow = "hidden";
    document.body.classList.add("ph-lightbox-open");
    document.addEventListener("touchmove", preventScroll, { passive: false });
    document.addEventListener("gesturestart", preventScroll, { passive: false });
    document.addEventListener("gesturechange", preventScroll, { passive: false });
    document.addEventListener("gestureend", preventScroll, { passive: false });
  }

  function unlockScroll() {
    document.removeEventListener("touchmove", preventScroll, false);
    document.removeEventListener("gesturestart", preventScroll, false);
    document.removeEventListener("gesturechange", preventScroll, false);
    document.removeEventListener("gestureend", preventScroll, false);
    document.body.classList.remove("ph-lightbox-open");
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.overflow = "";
    document.body.style.width = "";
    document.documentElement.style.overflow = "";
    window.scrollTo(0, scrollY);
  }

  function preventScroll(e) {
    if (open) {
      e.preventDefault();
    }
  }

  function pointerValues() {
    var keys = Object.keys(pointers);
    var out = [];
    var i;
    for (i = 0; i < keys.length; i++) {
      out.push(pointers[keys[i]]);
    }
    return out;
  }

  function distanceBetween(a, b) {
    var dx = b.x - a.x;
    var dy = b.y - a.y;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function onPointerDown(e) {
    if (e.pointerType === "mouse" && e.button !== 0) {
      return;
    }
    pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
    pointerCount = Object.keys(pointers).length;
    if (stage.setPointerCapture) {
      try {
        stage.setPointerCapture(e.pointerId);
      } catch (err) {}
    }
    if (pointerCount === 1) {
      didPinch = false;
      didMove = false;
      gestureStartX = e.clientX;
      gestureStartY = e.clientY;
      panLastX = e.clientX;
      panLastY = e.clientY;
    } else if (pointerCount === 2) {
      didPinch = true;
      var pts = pointerValues();
      pinchStartDist = distanceBetween(pts[0], pts[1]) || 1;
      pinchStartScale = scale;
      pinchStartTx = tx;
      pinchStartTy = ty;
      var midX = (pts[0].x + pts[1].x) / 2;
      var midY = (pts[0].y + pts[1].y) / 2;
      var origin = pointFromClient(midX, midY);
      pinchOriginX = origin.x;
      pinchOriginY = origin.y;
    }
  }

  function onPointerMove(e) {
    if (!pointers[e.pointerId]) {
      return;
    }
    pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
    pointerCount = Object.keys(pointers).length;
    if (pointerCount >= 2) {
      var pts = pointerValues();
      var dist = distanceBetween(pts[0], pts[1]) || 1;
      var next = pinchStartScale * (dist / pinchStartDist);
      scale = pinchStartScale;
      tx = pinchStartTx;
      ty = pinchStartTy;
      zoomToward(next, pinchOriginX, pinchOriginY);
      applyTransform(false);
      return;
    }
    var dx = e.clientX - gestureStartX;
    var dy = e.clientY - gestureStartY;
    if (Math.abs(dx) > MOVE_PX || Math.abs(dy) > MOVE_PX) {
      didMove = true;
    }
    if (scale > 1.01) {
      tx += e.clientX - panLastX;
      ty += e.clientY - panLastY;
      panLastX = e.clientX;
      panLastY = e.clientY;
      clampPan();
      applyTransform(false);
      return;
    }
    if (!didPinch) {
      imgEl.style.transition = "none";
      imgEl.style.transform = "translate(" + dx + "px, " + dy + "px) scale(1)";
      if (root && dy > 0 && Math.abs(dy) > Math.abs(dx)) {
        root.style.setProperty("--ph-lightbox-drag", String(clamp(1 - dy / 400, 0.4, 1)));
      }
    }
  }

  function finishGesture(e) {
    var id = e.pointerId;
    var wasPinch = didPinch;
    delete pointers[id];
    pointerCount = Object.keys(pointers).length;
    if (pointerCount > 0) {
      var remaining = pointerValues()[0];
      if (remaining) {
        gestureStartX = remaining.x;
        gestureStartY = remaining.y;
        panLastX = remaining.x;
        panLastY = remaining.y;
      }
      return;
    }
    root.style.removeProperty("--ph-lightbox-drag");
    var dx = e.clientX - gestureStartX;
    var dy = e.clientY - gestureStartY;
    if (wasPinch) {
      clampPan();
      applyTransform(true);
      return;
    }
    if (scale > 1.01) {
      clampPan();
      applyTransform(true);
      return;
    }
    if (Math.abs(dx) > SWIPE_X && Math.abs(dx) > Math.abs(dy) * 1.15) {
      if (dx < 0) {
        showAt(index + 1);
      } else {
        showAt(index - 1);
      }
      return;
    }
    if (dy > SWIPE_Y && Math.abs(dy) > Math.abs(dx)) {
      closeLightbox();
      return;
    }
    applyTransform(true);
    if (!didMove) {
      var now = Date.now();
      var tapDx = e.clientX - lastTapX;
      var tapDy = e.clientY - lastTapY;
      var isDouble =
        now - lastTapAt < DOUBLE_TAP_MS && tapDx * tapDx + tapDy * tapDy < DOUBLE_TAP_PX * DOUBLE_TAP_PX;
      lastTapAt = now;
      lastTapX = e.clientX;
      lastTapY = e.clientY;
      if (isDouble && e.target === imgEl) {
        lastTapAt = 0;
        var origin = pointFromClient(e.clientX, e.clientY);
        if (scale > 1.01) {
          scale = MIN_SCALE;
          tx = 0;
          ty = 0;
        } else {
          zoomToward(DOUBLE_TAP_SCALE, origin.x, origin.y);
        }
        applyTransform(true);
        return;
      }
      if (e.target !== imgEl && !e.target.closest("button")) {
        closeLightbox();
      }
    }
  }

  function onPointerUp(e) {
    if (!pointers[e.pointerId]) {
      return;
    }
    finishGesture(e);
  }

  function onWheel(e) {
    if (!open) {
      return;
    }
    e.preventDefault();
    var origin = pointFromClient(e.clientX, e.clientY);
    var factor = e.deltaY > 0 ? 0.9 : 1.1;
    zoomToward(scale * factor, origin.x, origin.y);
    applyTransform(false);
  }

  function onKeydown(e) {
    if (!open) {
      return;
    }
    if (e.key === "Escape") {
      e.preventDefault();
      closeLightbox();
      return;
    }
    if (e.key === "ArrowLeft") {
      e.preventDefault();
      showAt(index - 1);
      return;
    }
    if (e.key === "ArrowRight") {
      e.preventDefault();
      showAt(index + 1);
      return;
    }
    if (e.key === "Tab" && root) {
      var focusable = root.querySelectorAll("button:not([hidden])");
      if (!focusable.length) {
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  function setNavVisibility() {
    var many = images.length > 1;
    if (prevBtn) {
      prevBtn.hidden = !many;
    }
    if (nextBtn) {
      nextBtn.hidden = !many;
    }
    if (counterEl) {
      counterEl.hidden = !many;
    }
  }

  function showAt(nextIndex) {
    refreshImageList();
    if (!images.length) {
      closeLightbox();
      return;
    }
    index = ((nextIndex % images.length) + images.length) % images.length;
    var source = images[index];
    currentSource = source;
    resetZoom();
    var preview = source.currentSrc || source.getAttribute("src") || "";
    var hi = toHiRes(source);
    imgEl.alt = source.getAttribute("alt") || "";
    imgEl.src = preview;
    var fig = source.closest("figure");
    var figCaption = fig && fig.querySelector("figcaption");
    var caption = (figCaption && figCaption.textContent.trim()) || imgEl.alt;
    if (captionEl) {
      captionEl.textContent = caption;
      captionEl.hidden = !caption;
    }
    if (counterEl) {
      counterEl.textContent = index + 1 + " / " + images.length;
    }
    setNavVisibility();
    hiResToken += 1;
    var token = hiResToken;
    if (hi && hi !== preview) {
      var probe = new Image();
      probe.onload = function () {
        if (open && token === hiResToken) {
          imgEl.src = hi;
        }
      };
      probe.src = hi;
    }
  }

  function openAt(img) {
    refreshImageList();
    var i = images.indexOf(img);
    if (i < 0) {
      return;
    }
    ensureDom();
    lastFocus = document.activeElement;
    open = true;
    root.hidden = false;
    root.setAttribute("aria-hidden", "false");
    root.classList.add("is-open");
    lockScroll();
    showAt(i);
    if (closeBtn) {
      closeBtn.focus();
    }
  }

  function closeLightbox() {
    if (!open) {
      return;
    }
    open = false;
    currentSource = null;
    pointers = {};
    pointerCount = 0;
    root.classList.remove("is-open");
    root.classList.remove("is-zoomed");
    root.style.removeProperty("--ph-lightbox-drag");
    root.hidden = true;
    root.setAttribute("aria-hidden", "true");
    unlockScroll();
    resetZoom();
    if (lastFocus && typeof lastFocus.focus === "function") {
      lastFocus.focus();
    }
    lastFocus = null;
  }

  function ensureDom() {
    if (root) {
      return;
    }
    root = document.createElement("div");
    root.className = "ph-lightbox";
    root.hidden = true;
    root.setAttribute("role", "dialog");
    root.setAttribute("aria-modal", "true");
    root.setAttribute("aria-label", "Image viewer");
    root.setAttribute("aria-hidden", "true");
    root.innerHTML =
      '<div class="ph-lightbox__backdrop"></div>' +
      '<div class="ph-lightbox__stage">' +
      '<img class="ph-lightbox__img" alt="" draggable="false">' +
      "</div>" +
      '<button type="button" class="ph-lightbox__close" aria-label="Close">' +
      '<span aria-hidden="true">&times;</span>' +
      "</button>" +
      '<button type="button" class="ph-lightbox__prev" aria-label="Previous image">' +
      '<span aria-hidden="true">&#8249;</span>' +
      "</button>" +
      '<button type="button" class="ph-lightbox__next" aria-label="Next image">' +
      '<span aria-hidden="true">&#8250;</span>' +
      "</button>" +
      '<div class="ph-lightbox__meta">' +
      '<span class="ph-lightbox__counter"></span>' +
      '<p class="ph-lightbox__caption"></p>' +
      "</div>";
    document.body.appendChild(root);
    stage = root.querySelector(".ph-lightbox__stage");
    imgEl = root.querySelector(".ph-lightbox__img");
    captionEl = root.querySelector(".ph-lightbox__caption");
    counterEl = root.querySelector(".ph-lightbox__counter");
    prevBtn = root.querySelector(".ph-lightbox__prev");
    nextBtn = root.querySelector(".ph-lightbox__next");
    closeBtn = root.querySelector(".ph-lightbox__close");
    closeBtn.addEventListener("click", closeLightbox);
    prevBtn.addEventListener("click", function () {
      showAt(index - 1);
    });
    nextBtn.addEventListener("click", function () {
      showAt(index + 1);
    });
    root.querySelector(".ph-lightbox__backdrop").addEventListener("click", closeLightbox);
    stage.addEventListener("pointerdown", onPointerDown);
    stage.addEventListener("pointermove", onPointerMove);
    stage.addEventListener("pointerup", onPointerUp);
    stage.addEventListener("pointercancel", onPointerUp);
    stage.addEventListener("wheel", onWheel, { passive: false });
    document.addEventListener("keydown", onKeydown);
  }

  function bindImage(img) {
    if (img.getAttribute("data-ph-lightbox") === "true") {
      return;
    }
    img.setAttribute("data-ph-lightbox", "true");
    img.setAttribute("role", "button");
    img.setAttribute("tabindex", "0");
    img.classList.add("ph-lightbox-source");
    if (!img.getAttribute("aria-label")) {
      var alt = img.getAttribute("alt") || "";
      img.setAttribute("aria-label", alt ? "View larger image: " + alt : "View larger image");
    }
    var wrap = img.closest(".article-image, .article__image-wrapper") || img.parentElement;
    if (wrap) {
      wrap.classList.add("ph-lightbox-source-wrap");
    }
    img.addEventListener("click", function (e) {
      e.preventDefault();
      openAt(img);
    });
    img.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        openAt(img);
      }
    });
  }

  function bindAll(scope) {
    if (!isArticlePage()) {
      return;
    }
    var list = collectImages(scope);
    var i;
    for (i = 0; i < list.length; i++) {
      bindImage(list[i]);
    }
  }

  function init() {
    if (!isArticlePage()) {
      return;
    }
    bindAll(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", function (e) {
    if (e && e.target && e.target.querySelectorAll) {
      bindAll(e.target);
    }
  });
})();
